import { createFileRoute } from '@tanstack/react-router';
import CasePreferences from '../../../../Components/CasePreferences';
import { caseRouteSchema } from '../../../../Utils/routeSchema';

export const Route = createFileRoute('/(main)/_layout/cases/$caseId/preferences')({
  params: {
    parse: (params) => caseRouteSchema.parse(params),
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { caseId } = Route.useParams();
  return <CasePreferences caseId={caseId} />;
}
